export default "__VITE_ASSET__6b8bd97e__"